import { Form } from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import messages from "constants/messages";

import { requestPasswordReset } from "../lib/auth-api";
import { getRequestResetPrefill, getTargetResetUrl } from "../lib/auth-routes";

const { REQUEST_RESET_PASSWORD_ERROR } = messages;

export const useRequestPasswordReset = () => {
  const [form] = Form.useForm();
  const location = useLocation();

  const [alertType, setAlertType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const usernameEmail = getRequestResetPrefill(location.search);

    if (usernameEmail) {
      form.setFieldsValue({ usernameEmail });
    }
  }, [form, location.search]);

  const handleSubmit = async values => {
    const { usernameEmail } = values;

    setLoading(true);
    setMessage("");

    try {
      const response = await requestPasswordReset({
        targetResetUrl: getTargetResetUrl(),
        usernameEmail
      });

      if (response.data.Response === "Success") {
        setAlertType("success");
        setMessage(response.data.Message);
        form.resetFields();
        return;
      }

      setAlertType("error");
      setMessage(response.data.ErrorMessage);
    } catch (error) {
      setAlertType("error");
      setMessage(REQUEST_RESET_PASSWORD_ERROR);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    alertType,
    form,
    handleSubmit,
    loading,
    message
  };
};